export default "__VITE_ASSET__BwRl3kaJ__"